import { memo } from 'react';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3, TextLabel2, TextBody, TextLabel1, Link } from '@cbhq/cds-web/typography';
import { SpotSquare } from '@cbhq/cds-web/illustrations';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { Chip } from '@cbhq/cds-web/chips';
import SummaryCard from '@/components/PoolDetails/PoolDetailsSummary/SummaryCard';
import { useUSDCRewardsData } from '@/hooks/useUSDCRewardsData';
import { DisplayType, format } from '@/utils/numberFormatter';

export const USDCRewardsCard = memo(function USDCRewardsCard() {
  const { totalUsdcUsd, usdcPoolsInvested, isInstitutional, message, learnMoreUrl, learnMore } =
    useUSDCRewardsData();

  const header = (
    <VStack justifyContent="space-between" gap={2}>
      <HStack justifyContent="space-between" alignItems="center">
        <TextTitle3 noWrap as="h2" testID="earn-card-title">
          USDC rewards
        </TextTitle3>

        <Chip justifyContent="center">
          <HStack alignItems="center" gap={0.5}>
            <Box
              width={10}
              height={10}
              background={usdcPoolsInvested > 0 ? 'bgPositive' : 'bgNegative'}
              borderRadius={1000}
            />
            <TextLabel1 noWrap as="span">
              {usdcPoolsInvested > 0 ? 'Earning' : 'Not earning'}
            </TextLabel1>
          </HStack>
        </Chip>
      </HStack>
      <HStack justifyContent="space-between" alignItems="center" paddingEnd={1}>
        <TextLabel2 color="fgMuted" as="p">
          {message}{' '}
          <Link href={learnMoreUrl} target="_blank" style={{ whiteSpace: 'nowrap' }}>
            {learnMore}
          </Link>
        </TextLabel2>
        <Box flexShrink={0}>
          <SpotSquare name="retailUSDCRewards" scaleMultiplier={0.5} />
        </Box>
      </HStack>
    </VStack>
  );

  return (
    <SummaryCard header={header}>
      <VStack gap={0}>
        <ListCell
          minHeight={0}
          title="Total USDC"
          detail={
            <TextBody as="p">{format({ value: totalUsdcUsd, type: DisplayType.Fiat })}</TextBody>
          }
        />
        <ListCell
          minHeight={0}
          title="Reward rate"
          detail={<TextBody color="fgPositive">{isInstitutional && 'Up to '} 2.0%</TextBody>}
        />
        <ListCell
          minHeight={0}
          title="USDC pools invested"
          detail={<TextBody as="p">{usdcPoolsInvested}</TextBody>}
        />
      </VStack>
    </SummaryCard>
  );
});
